import Box, { Align } from 'components/shared/Box'
import { HiddenCheckbox, CustomCheckbox, CheckboxLabel } from './styles'
import Icon from 'components/shared/Icon'

interface CheckboxProps {
    children: React.ReactNode
    isChecked: boolean
    setIsChecked: () => void
    align?: Align | [Align, Align]
    testId?: string
    gap?: number
    isFocusable?: boolean
}

const Checkbox = ({
    children,
    isChecked,
    setIsChecked,
    align = 'flex-start',
    testId,
    gap,
    isFocusable = true,
}: CheckboxProps) => (
    <CheckboxLabel
        onClick={setIsChecked}
        direction="row"
        gap={gap ?? 12}
        align={align}
        data-testid={testId}
    >
        <Box>
            <HiddenCheckbox
                checked={isChecked}
                tabIndex={isFocusable ? 0 : -1}
                readOnly
            />
            <CustomCheckbox
                isChecked={isChecked}
                align="center"
                justify="center"
                data-testid={testId ? `${testId}-inner` : undefined}
            >
                {isChecked && (
                    <Icon variant="checkmark" color="grayscale_0" size={12} />
                )}
            </CustomCheckbox>
        </Box>
        {children}
    </CheckboxLabel>
)

export default Checkbox
